class HHAnimatedDetails extends HTMLElement {
  constructor() {
    super()

    this.el = this.querySelector('details')
    this.summary = this.el.querySelector('summary')
    this.content = this.el?.querySelector('.content')

    this.animation = null
    this.isClosing = false
    this.isExpanding = false
  }

  connectedCallback() {
    this.summary.addEventListener('click', (e) => this.onClick(e))

    this.backTriggers.forEach(trigger => {
      trigger.addEventListener('click', this.close.bind(this))
    })
  }

  onClick(e) {
    e?.preventDefault()

    if (this.isClosing || !this.el.open) {
      this.open()
    } else if (this.isExpanding || this.el.open) {
      this.close()
    }
  }

  close(e) {
    e?.preventDefault()
    this.isClosing = true

    if (this.type == 'accordion') {
      this.el.style.overflow = 'hidden'
      const startHeight = `${this.el.offsetHeight}px`
      const endHeight = `calc(${this.summary.offsetHeight}px + var(--content-diff, 0))`

      if (this.animation) {
        this.animation.cancel()
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 300,
          easing: 'ease-out',
        }
      )

      this.animation.onfinish = () => this.onAnimationFinish(false)
      this.animation.oncancel = () => (this.isClosing = false)
    } else {
      this.broadcast(false)

      this.el.classList.add('animating')
      this.el.classList.remove('animated-in')

      if (this.animation) {
        clearTimeout(this.animation)
        this.isClosing = false
      }

      this.animation = setTimeout(() => {
        this.onAnimationFinish(false)
        this.el.classList.remove('animating')
      }, this.animateTime)
    }
  }

  open() {
    if (this.type == 'accordion') {
      const wrapper = this.closest('.js-items')
      wrapper?.querySelectorAll('.js-animated-details').forEach(item => item.close())
      this.el.style.height = `${this.el.offsetHeight}px`
    }

    this.el.open = true
    window.requestAnimationFrame(() => this.show())
  }

  show() {
    this.isExpanding = true

    if (this.type == 'accordion') {
      this.el.style.overflow = 'hidden'
      const startHeight = `${this.el.offsetHeight}px`
      const endHeight = `${
        this.summary.offsetHeight + this.content.offsetHeight
      }px`

      if (this.animation) {
        this.animation.cancel()
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 300,
          easing: 'ease-out',
        }
      )
      this.animation.onfinish = () => this.onAnimationFinish(true)
      this.animation.oncancel = () => (this.isExpanding = false)
    } else {
      this.broadcast()
      this.el.classList.add('animating')
      this.el.classList.add('animated-in')

      if (this.animation) {
        clearTimeout(this.animation)
        this.isExpanding = false
      }

      this.animation = setTimeout(() => {
        this.onAnimationFinish(true)
        this.el.classList.remove('animating')
      }, this.animateTime)
    }
  }

  broadcast(open = true) {
    if (this.setMaxWidth) {
      this.dispatchEvent(
        new CustomEvent('toggleMaxWidth', {
          bubbles: true,
          composed: true,
          detail: {
            value: open,
          },
        })
      )
    }
  }

  onAnimationFinish(open) {
    this.el.open = open
    this.animation = null
    this.isClosing = false
    this.isExpanding = false
    if (this.type == 'accordion') {
      this.el.style.height = this.el.style.overflow = ''
    } else {
      this.el.classList.remove('animating')
    }
  }

  get backTriggers () {
    return this.querySelectorAll('.js-details-back')
  }

  get animateTime () {
    return parseInt(this.getAttribute('data-animate') || '300')
  }

  get setMaxWidth () {
    return this.el.getAttribute('set-max-width') == 'true'
  }

  get type () {
    return this.el.getAttribute('type') || 'accordion'
  }
}

window.customElements.define('hh-animated-details', HHAnimatedDetails)
